__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => (typeof console !== "undefined" && console.warn && console.warn(msg));
	var uniqueName = "ltl-angular-opspkr";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@angular/common/http/testing", "15.2.10", () => (Promise.all([__webpack_require__.e(269), __webpack_require__.e(497), __webpack_require__.e(592), __webpack_require__.e(565)]).then(() => (() => (__webpack_require__(9263))))));
			register("@angular/common/http", "15.2.10", () => (Promise.all([__webpack_require__.e(269), __webpack_require__.e(493), __webpack_require__.e(987), __webpack_require__.e(782)]).then(() => (() => (__webpack_require__(8987))))));
			register("@angular/common", "15.2.10", () => (Promise.all([__webpack_require__.e(269), __webpack_require__.e(666)]).then(() => (() => (__webpack_require__(4666))))));
			register("@angular/core", "15.2.10", () => (Promise.all([__webpack_require__.e(419), __webpack_require__.e(71)]).then(() => (() => (__webpack_require__(2560))))));
			register("@angular/router", "15.2.10", () => (Promise.all([__webpack_require__.e(269), __webpack_require__.e(493), __webpack_require__.e(419), __webpack_require__.e(668), __webpack_require__.e(706), __webpack_require__.e(833)]).then(() => (() => (__webpack_require__(9706))))));
			register("@xpo-ltl/ngx-mexico", "15.0.36", () => (Promise.all([__webpack_require__.e(269), __webpack_require__.e(493), __webpack_require__.e(419), __webpack_require__.e(497), __webpack_require__.e(857), __webpack_require__.e(831), __webpack_require__.e(668), __webpack_require__.e(975)]).then(() => (() => (__webpack_require__(7975))))));
			register("date-fns", "2.30.0", () => (__webpack_require__.e(823).then(() => (() => (__webpack_require__(3823))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};